import { apiRoutes, createStandardCrudApi } from "./entityApiShared.js";
import type { CrudApi, EntityCreateRequest, EntityRecord, EntityUpdateRequest } from "../types/api.types.js";

export type ReferencetypeDto = EntityRecord;
export type ReferencetypeCreateRequest = EntityCreateRequest;
export type ReferencetypeUpdateRequest = EntityUpdateRequest;

export const referenceTypeApi: CrudApi<ReferencetypeDto, ReferencetypeCreateRequest, ReferencetypeUpdateRequest> = createStandardCrudApi({
  list: apiRoutes.referenceTypes.list,
  get: apiRoutes.referenceTypes.get,
  create: apiRoutes.referenceTypes.create,
  update: apiRoutes.referenceTypes.update,
  delete: apiRoutes.referenceTypes.delete,
  activate: apiRoutes.referenceTypes.activate,
  deactivate: apiRoutes.referenceTypes.deactivate,
  schema: apiRoutes.referenceTypes.schema,
  validate: apiRoutes.referenceTypes.validate,
  dependencies: apiRoutes.referenceTypes.dependencyCheck,
  dropdown: apiRoutes.referenceTypes.dropdownOptions,
});
